import { render, staticRenderFns } from "./CalendarMonteIA.vue?vue&type=template&id=74d31dfa&"
import script from "./CalendarMonteIA.vue?vue&type=script&lang=js&"
export * from "./CalendarMonteIA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports